<template>
    <div id="wrapper" style="background-color: #fff; padding-bottom: 30px">
        <div class="dis-table">
            <div class="table-cell">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-sm-8">
                            <div class="page-title mb-4 text-dark">{{i18n('Tickets')}}</div>
                            <div :class="{hidden: displayNoneLoop}" class="carousel slide" data-ride="carousel"
                                 id="carouselCheck">
                                <div class="carousel-inner">
                                    <div :class="{'active': k === 0}" :id="'ticket' + k" class="ticket carousel-item"
                                         v-for="(ticket, k) in tickets">
                                        <img :src="ticket.image" alt=""/>
                                    </div>
                                </div>
                                <a class="carousel-control-prev control-item" data-slide="prev" href="#carouselCheck"
                                   role="button" v-show="tickets.length > 1">
                                    <i class="mdi mdi-chevron-left" style="color: #000; font-size: 40px;"></i>
                                </a>
                                <a class="carousel-control-next control-item" data-slide="next" href="#carouselCheck"
                                   role="button" v-show="tickets.length > 1">
                                    <i class="mdi mdi-chevron-right" style="color: #000; font-size: 40px;"></i>
                                </a>
                            </div>

                            <div :class="{active : displayNoneLoop}" class="hidden">
                                <div class="tickets" v-for="(ticket, k) in tickets">
                                    <img :src="ticket.image" alt=""/>
                                </div>
                            </div>

                            <p class="txt">Сфотографируйте или</p>
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <button @click="printImage" class="btn btn-primary btn-next" type="button">
                                        Распечатать по одному
                                    </button>
                                    <button @click="printAll" class="btn btn-primary btn-next" type="button">Распечатать
                                        все билеты
                                    </button>
                                    <!-- alx print an e-pos pdf receipe -->
                                    <button @click="getLastEposPaycheck" class="btn btn-primary btn-next" type="button" v-if="epos && epos.enabled">Распечатать
                                        чек
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!--/wrapper-->
</template>

<script>
    export default {
        data() {
            return {
                displayNoneLoop: false,
                ticketCount: 1,
                epos_paycheck: null,
            }
        },
        props: {
            tickets: {
                type: Array,
                required: true
            },
            epos: {
                type: Object,
                required: false
            },
        },
        methods: {
            //alx e-pos
            getLastEposPaycheck() {
                this.$http.post(this.epos.url, {
                    "token": this.epos.token,
                    "method": "printLastPaycheck"
                    }).then(res2 => {
                        if (res2.data.error) {
                            if (res2.data.message) {
                                this.errorMsg("E-POS: " + res2.data.message)
                            }
                            return;
                        }
                        this.epos_paycheck = res2.data.message;

                    }).catch((err) => {
                        this.errorMsg("E-POS: Невозможно получить данные! " + err)
                    }).finally(() => {
                        // FIXME: ...
                        this.printReceipt();
                    })
            },
            errorMsg(message) {
                if (_.isArray(message)) {
                    message.forEach(error => {
                        Vue.notify({
                            type: 'error',
                            group: 'foo',
                            title: '',
                            text: error.message
                        });
                    })
                } else {
                    Vue.notify({
                        type: 'error',
                        group: 'foo',
                        title: '',
                        text: message
                    });
                }
            },

            printImage() {
                this.displayNoneLoop = false;
                let ticketImg = document.querySelector('.active.ticket').innerHTML;
                this.printImageSeparateWindow(ticketImg);
            },
            printAll() {
                this.displayNoneLoop = false;
                let tickets = document.getElementsByClassName('tickets');
                this.printImageSeparateWindow(tickets);
            },
            printImageSeparateWindow(ticketImgEl) {
                let mywindow = window.open('', 'PRINT', 'height=800,width=800');
                mywindow.document.write('<html><head><title>' + document.title + '</title>');
                mywindow.document.write('</head><body >');
                if (HTMLCollection.prototype.isPrototypeOf(ticketImgEl)) {
                    for (let i = 0; i < ticketImgEl.length; i++) {
                        let ticketImg = ticketImgEl[i].innerHTML + '<hr>';
                        mywindow.document.write(ticketImg);
                    }
                } else {
                    mywindow.document.write(ticketImgEl);
                }
                mywindow.document.write('</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                let imgEls = mywindow.document.querySelectorAll('img');
                let loadingCnt = 1;
                imgEls.forEach(el => {
                    el.addEventListener('load', function () {
                        if (loadingCnt < imgEls.length) {
                            loadingCnt++;
                            return;
                        }
                        mywindow.print();
                        setTimeout(() => {
                            mywindow.close();
                        }, 1000);
                    });
                });
            },
            //alx print an e-pos PDF receipe
            printReceipt() {

                let b64toBlob = (content, contentType) => {
                    contentType = contentType || '';
                    const sliceSize = 512;
                    const byteCharacters = window.atob(content);

                    const byteArrays = [];
                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);
                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    const blob = new Blob(byteArrays, {
                        type: contentType
                    });
                    return blob;
                };

                let printPdf = function (pdfBase64) {

                    let blob = null;
                    blob = b64toBlob(pdfBase64, 'application/pdf');
                    const blobURL = URL.createObjectURL(blob);

                    let mywindow = window.open('', 'PRINT', 'height=800,width=800');
                    mywindow.document.write('<html><head><title>' + document.title + '</title>');
                    mywindow.document.write('</head><body >');

                    let iframe = mywindow.document.createElement('iframe');
                    mywindow.document.body.appendChild(iframe);

                    mywindow.document.write('</body></html>');

                    mywindow.document.close(); // necessary for IE >= 10
                    mywindow.focus(); // necessary for IE >= 10*/

                    iframe.style.display = 'none';
                    iframe.onload = function() {
                        setTimeout(function() {
                            iframe.focus();
                            iframe.contentWindow.print();

                        }, 500);
                    };
                    iframe.src = blobURL;
                }

                if (this.epos_paycheck) {
                    //console.log("this.epos_paycheck", this.epos_paycheck);
                    printPdf(this.epos_paycheck);
                }
            }
        }
    }
</script>

<style>
    .hidden {
        display: none;
    }

    .active {
        display: block;
    }
</style>
